import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Field } from 'redux-form';

// Global Types
import { AppState } from 'services/types';
import { HarvestPrintPropertiesProps } from 'services/harvestPrintProperties/types';

// Global Form
// @ts-ignore
import { RenderDropdown } from 'forms';

// Local Selectors
import { selectOptions } from './selectors';

interface OwnProps extends HarvestPrintPropertiesProps {
    label?: string;
    placeholder?: string;
    name: string;
    validate?: Function;
    normalize?: Function;
    disabled?: boolean;
}

interface ConnectedProps {
    options: {
        id: number;
        text: string;
        name: string;
    }[];
}

type Props = OwnProps & ConnectedProps;

export class HarvestBinSuitabilityTypeahead extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const {
            options,
            label,
            placeholder,
            name,
            validate,
            normalize,
            disabled
        } = this.props;
        if (!options.length) {
            return null;
        }
        
        return (
            <Field
                component={RenderDropdown}
                label={label}
                name={name}
                options={options}
                placeholder={placeholder}
                clearable={!disabled}
                fluid
                search
                selection
                validate={validate}
                normalize={normalize}
                disabled={disabled}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    options: selectOptions
});

export default connect(mapStateToProps)(HarvestBinSuitabilityTypeahead);
